<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'consumo_materia_prima'"><ConsumoMateriaPrima /></div>
    <div v-if="view === 'scrap_almacen_laser'"><ScrapAlmacenLaser /></div>
    <div v-if="view === 'vena_scrap'"><VenaScrap /></div>
    <div v-if="view === 'inventario'"><Inventario /></div>
    <div v-if="view === 'cat_productos'"><CrudProductos /></div>
    <div v-if="view === 'cat_maquinas'"><CrudCatMaquinas /></div>
    <div v-if="view === 'operadores'"><CrudOperadores /></div>
    <div v-if="view === 'pigmentos'"><CrudPigmentos /></div>
    <div v-if="view === 'tpus'"><CrudTpus /></div>
    <div v-if="view === 'codigos_defectos'"><CrudCodigosDefectos /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import Inventario from "@/components/Inventario/Inventario.vue";
import ConsumoMateriaPrima from "@/components/Inventario/Formularios/MateriaPrima/ConsumoMateriaPrima.vue";
import ScrapAlmacenLaser from "@/components/Inventario/Formularios/ScrapAlmacenLaser/ScrapAlmacenLaser.vue";
import VenaScrap from "@/components/Inventario/Formularios/VenaScrap/VenaScrap.vue";
import CrudProductos from "@/components/Inventario/CrudProductos.vue";
import CrudCatMaquinas from "@/components/Inventario/CrudCatMaquinas.vue";
import CrudOperadores from "@/components/Inventario/CrudOperadores.vue";
import CrudPigmentos from "@/components/Inventario/CrudPigmentos.vue";
import CrudTpus from "@/components/Inventario/CrudTpus.vue";
import CrudCodigosDefectos from "@/components/Inventario/CrudCodigosDefectos.vue";

const view = ref("inventario");
</script>
